import { AlphaQuotePriceStrictCalculatedData } from '@snap-types/models/alpha-quote-price';
import { AlphaQuoteEvaluationStatus } from '@snap-types/models/enums';

import type { BooleanValue, DecimalValue, NumberValue } from './value';

export type QuantityBreak = {
  uuid: string;
  lineItemUuid: string;

  isPending: boolean;
  evaluationStatus: AlphaQuoteEvaluationStatus;
  calculatedData: CalculatedQuantityBreakData | null;

  quantity: DecimalValue;

  sems1Cost: DecimalValue;
  sems2Cost: DecimalValue;

  osp2Price: DecimalValue;
  osp3Price: DecimalValue;

  /**
   * Manual overrides. The user's value is kept when an override is switched
   * off, so switching it back on restores what they last entered.
   */
  userGrossMargin: DecimalValue;
  grossMarginIsOverridden: BooleanValue;

  userUnitPrice: DecimalValue;
  unitPriceIsOverridden: BooleanValue;

  userLeadTimeWeeks: NumberValue;
  leadTimeWeeksIsOverridden: BooleanValue;
};

export type CalculatedQuantityBreakData = AlphaQuotePriceStrictCalculatedData;

export type QuantityBreakFieldKey = keyof Omit<
  QuantityBreak,
  'uuid' | 'lineItemUuid' | 'evaluationStatus' | 'calculatedData' | 'isPending'
>;

export const quantityBreakFieldModel = 'quantityBreak';
export type QuantityBreakFieldModel = typeof quantityBreakFieldModel;
